const DASHBOARD_DATAS_PENDING = 'dashboard_datas_pending';
const DASHBOARD_DATAS_FAILED = 'dashboard_datas_failed';
const DASHBOARD_DATAS_DOWNLOADED = 'dashboard_datas_downloaded';
const DASHBOARD_LATE_RENTS_DOWNLOADED = 'dashboard_late_rents_downloaded';
const DASHBOARD_DATAS_RESET = 'dashboard_datas_reset';

export {
  DASHBOARD_DATAS_PENDING,
  DASHBOARD_DATAS_FAILED,
  DASHBOARD_DATAS_DOWNLOADED,
  DASHBOARD_LATE_RENTS_DOWNLOADED,
  DASHBOARD_DATAS_RESET,
};



// WEBPACK FOOTER //
// ./src/store/dashboardDatas/types.js